import request from '@/helpers/request'

// auService have all api of user when not login
export default {
  async get() {
    return request.get('key-visual')
  },
  async popupReward() {
    return request.get('popup-reward')
  }
}
